export default class Action {
  constructor (data) {
    this.data = data
  }
}
